<template>
  <v-card>
    <v-card-title><h3>Inventory report</h3></v-card-title>
    <v-card-text>

      <v-layout row wrap>
        <v-flex xs12 md5 class="text-xs-center" px-1 mt-2>
          <v-flex class="date__picker">
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="from"
                  label="Period starts from:"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="from" @input="menu = false"></v-date-picker>
            </v-menu>
          </v-flex>
        </v-flex>

        <v-flex xs12 md5 class="text-xs-center" px-1 mt-2>
          <v-flex class="date__picker">
            <v-menu
              v-model="menu1"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="to"
                  label="Period end on:"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="to" @input="menu1 = false"></v-date-picker>
            </v-menu>
          </v-flex>
        </v-flex>

        <v-flex xs12 md2 class="text-xs-center">
          <v-flex xs12>
            <v-btn large @click="search">
              <v-icon>search</v-icon>
            </v-btn>
          </v-flex>

          <v-flex xs12 mt-5>
            <v-flex v-for="(error, i) in errors" :key="i">
              <v-alert v-if="error.status" type="error" :value="true">
                {{ error.text }}
              </v-alert>
            </v-flex>
          </v-flex>
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex>
          <h3>Report:</h3>
          <v-flex right v-if="report.length">
            <v-btn>
              <json-c-s-v
                :name="dataFile"
                :labels="labelsCSV"
                :fields="fieldsCSV"
                :data="report"
              >
                Export CSV
                <v-icon></v-icon>
              </json-c-s-v>
            </v-btn>
          </v-flex>
          <v-flex xs12 md12>
            <v-data-table
              :items="report"
              :headers="reportHeaders"
              :loading="loading"
              hide-actions
            >
              <template slot="items" slot-scope="props">
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.all_quantity }}</td>
              </template>
            </v-data-table>
          </v-flex>
        </v-flex>
      </v-layout>

    </v-card-text>
  </v-card>
</template>

<script>
  import servicesAPI from '@/api/resources/services'
  import JsonCSV from 'vue-json-csv'
  import moment from 'moment'

  export default {
    components: { JsonCSV },
    data () {
      return {
        menu: false,
        menu1: false,
        from: null,
        to: null,
        report: [],
        dataFile: moment().format('YYYY-MM-DD') + '.csv',
        labelsCSV: {
          name: 'Product',
          all_quantity: 'Quantity'
        },
        fieldsCSV: ['name', 'all_quantity'],
        reportHeaders: [
          { text: 'Product', value: 'name' },
          { text: 'Quantity', value: 'cases.quantity' }
        ],
        loading: false,
        errors: {
          datesNotSelected: {
            status: false,
            text: 'Select from/to date range firstly'
          }
        }
      }
    },
    methods: {
      search () {
        for (let error in this.errors) {
          this.errors[error].status = false
        }

        this.loading = true

        if (!this.from || !this.to) {
          this.errors.datesNotSelected.status = true
          return false
        }

        servicesAPI.getReportQuantitiesSold(this.from, this.to).then(result => {
          this.report = result

          this.loading = false
        }, () => {
          this.loading = false
        })
      }
    }
  }
</script>

<style>
  .date__picker .v-input__slot {
    margin-bottom: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// InventoryReport.vue?288ab5fd